import { FC, useRef, useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { useCloseOnOutsideClick } from "../../../utils";

import styles from "./PageNavButton.module.scss";

export interface PageNavItem {
  id: string;
  title: string;
}

interface PageNavProps {
  items: PageNavItem[];
}

export const PageNavButton: FC<PageNavProps> = ({ items }) => {
  const [menuShown, setMenuShown] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useCloseOnOutsideClick(menuRef, () => setMenuShown(false));
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      ref={menuRef}
      className={styles.burger}
      onClick={() => setMenuShown((prev) => !prev)}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ borderColor: isHover ? "#7bdcb5" : "transparent" }}
    >
      <RxHamburgerMenu size="1.5rem" color={isHover ? "#7bdcb5" : "#a8a5a5"} />
      {menuShown && (
        <div className={styles.menu}>
          <ul className={styles.menuItems}>
            {items.map((item, ind) => {
              return (
                <li style={{ cursor: "pointer" }} key={ind}>
                  <a href={`#${item.id}`} onClick={() => setIsHover(false)}>
                    {item.title}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};
